export const environment = {
  production: true,
  apiUrl: '/api/',
  clientApiUrl: '/clientapi/v1/',
  clientApiV2Url: '/clientapi/v2/',
  aData: window.btoa('f9ad066f60f94672ae07509e03884c82:bc546cbebd6849b3922a3c16f38d2640')
};
